<template>
  <div class="playlist-group-base">
    <template v-if="closedItemList.filter(item => !item.shown).length > 0">
      <template v-for="(item, index) in closedItemList">
        <closed-item
          :class="`closed-item-${item.id}`"
          :all-lock="allLock"
          :item-data="item"
          :user-profile="userProfile"
          :key="`closed${index}`"
        />
      </template>
    </template>
    <template v-else>
      <div  v-if="!hasItems" class="no-items" :class="{ hasTabhead: hasTabhead }">
        <img src="/static/img/icons/uranaitv_logo_lite.svg" />
        <span v-if="targetList.tagId === 'history'">閲覧したコンテンツがありません</span>
        <span v-else-if="isCategory">該当のプレイリストがありません</span>
        <span v-else>該当するコンテンツがありません</span>
      </div>
      <template v-else v-for="(item, index) in itemsList">
        <playlist-item
          :all-lock="allLock"
          :item-data="item"
          :is-category="isCategory"
          :category-id="categoryId"
          :user-profile="userProfile"
          :is-seelater-history="isSeelaterHistory"
          :is-preview="isPreview"
          :key="index"
          @change-partner-click="onChangePartnerClick"
          @open-item="openItem"
        />
      </template>

      <!-- 特集の場合のレコメンドリスト -->
      <div class="features-recommend-base" v-if="checkFeatureRecommend
       && (!!featureRecommendList && featureRecommendList.length > 0)
       && !hideFeatureRecommend ">
        <div class="recommend-wrap">
            <div
              class="recommend-block"
              v-for="(rec, ridx) in featureRecommendList"
              :key="`frec${ridx}`"
            >
              <h4 v-if="!!rec.title && rec.title.length > 0" v-html="rec.title"></h4>
              <!--
              <a
                class="recommend-item"
                v-for="(item, iidx) in rec.items"
                :key="`item${iidx}`"
                :href="rec.url"
                @click.prevent="onRecommendItemClick(item)"
              >#{{item.name}}</a>
              -->
              <sec-features-list :list-data="rec" />
            </div>
        </div>

      </div>
    </template>

    <transition name="clbtn">
      <div class="fixed-button-base" v-if="hasClosedList">
        <BaseButton class="btn-fin-closedlist" label="配信中のメニューのみ表示する" @clicked="onFinishClosedListClick" :style="{opacity: isScrollBottom ? 0.7 : 1}"/>
      </div>
    </transition>
  </div>
</template>


<script>
import moment from 'moment'
import {mapState} from 'vuex'
import PlaylistItem from '@/utvStore/components/Playlist/PlaylistItem'
import BaseButton from '@/utvStore/components/common/BaseButton'
import ClosedItem from '@/utvStore/components/Playlist/ClosedItem'
import { MENU_ITEM_TYPE, PLAYLIST_TYPE } from '@/CONSTS/MENUS'
import * as type from '@/utvStore/store/mutation-types'
import SecFeaturesList from '@/utvStore/components/Toppage/section/SecFeaturesList'

export default {
  name: "PlaylistGroup",
  components: {SecFeaturesList, PlaylistItem, ClosedItem, BaseButton},
  data() {
    return {
      // allLock: false
      isScrollListenerAdded: false,
      shownItem: [],
      hasClosedList: false,
      isScrollBottom: false,
      hideFeatureRecommend: false,
    }
  },
  props: {
    allLock: {
      type: Boolean,
      default() {
        return false
      }
    },
    loadLock: {
      type: Boolean,
      default() {
        return false
      }
    },
    forceTabVisible: {
      type: Boolean,
      default() {
        return false
      }
    },
    targetList: {
      type: Object,
      default() {
        return []
      }
    },
    isCategory: {
      type: Boolean,
      default() {
        return false
      }
    },
    isFavlist: {
      type: Boolean,
      default() {
        return false
      }
    },
    categoryId: {
      type: Number,
      default: 0
    },
    userProfile: {
      type: Object,
      default() {
        return {}
      }
    },
    isSeelaterHistory: {
      type: Boolean,
      default: false
    },
    hasTabhead: {
      type: Boolean,
      default: false
    },
    isPreview: {
      type: Boolean,
      default: false,
    },
    showFeatureRecommend: {
      type: Boolean,
      default: false,
    },
    featureRecommendList: {
      type:Array,
    },
  },
  computed: {
    ...mapState({
      closedItems: states => states.item.closedItems,
      subscriptVideoData: states => states.item.subscVideoItems
    }),
    hasItems() {
      let rtn = false
      //カテゴリの時も同じ？
      rtn = !!this.itemsList ? this.itemsList.length > 0 : false
      return rtn
    },
    itemsList() {
      const rtnArr = []
      this.targetList.itemList.forEach(val=>{
        let itemData = {}
        //ビデオの場合、ビデオ情報を詰める
        if(val.itemType === MENU_ITEM_TYPE.movie){
            const videoDataOneList = this.subscriptVideoData.filter((data)=>{
            return data.subscript_store_product_id == val.videoId
          })
          const videoData = videoDataOneList.length > 0 ? videoDataOneList[0] : {}
          itemData = {...val, videoData}
        }else{
          itemData = {...val}
        }
        if(!itemData.closed) rtnArr.push(itemData)
      })
      return rtnArr
    },
    closedItemList(){
      // console.log('リストをチェック listType[%s/%s] isCategory[%s] %O %O', this.targetList.listType, PLAYLIST_TYPE.text, this.isCategory, this.closedItems, this.targetList)
      if(!this.isCategory) {
        const now = new moment()
        const rtn = this.closedItems.filter(t => {
          // console.log('  [id:%s] closedAtは:[%s] listType[%s] tag[%s] time[%s]', t.id, t.closedAt, this.targetList.listType === 1,(t.tags.find(m => m.id === +this.targetList.tagId) || this.isFavlist),now.isSameOrAfter(t.closedAt) )
          return this.targetList.listType === 1
            && (t.tags.find(m => m.id === +this.targetList.tagId) || this.isFavlist)
            && now.isSameOrAfter(t.closedAt)
          // && !t.shown
        })
        /*
        if (!this.isScrollListenerAdded) {
          this.isScrollListenerAdded = true
          document.querySelector('.list-body').addEventListener('scroll', this.onListScroll)
        }
         */
        this.hasClosedList = rtn.filter(item => !item.shown).length > 0
        if(this.hasClosedList) {
          document.querySelector('.list-body').addEventListener('scroll', this.onBottomCheck)
          this.$emit('has-closed-items')
        }
        // console.log('  -> rtnを返す hasClosedList[%s] %O ', this.hasClosedList, rtn)
        return rtn
      }else{
        return []
      }
    },
    checkFeatureRecommend() {
      // チェック用に作ったけどいったんスルー
      return this.showFeatureRecommend
    }
  },
  mounted(){
    // this.onListScroll()
  },
  methods: {
    openItem( menuData ) {
      this.$emit('open-item', menuData)
    },
    onFinishClosedListClick(){
      this.hasClosedList = false
      document.querySelector('.list-body').removeEventListener('scroll', this.onBottomCheck)
      this.$store.dispatch(type.SETSHOWN_CLOSED_ITEMS_CACHE, this.closedItemList.map(item => item.id))
      .then(()=>{
        this.$emit('finish-closed-view')
      })
    },
    onBottomCheck(e){
      const base = !!e ? e.target : document.querySelector('.list-body')
      const tab = base.querySelector('.tab-body')
      this.isScrollBottom = base.scrollTop + base.clientHeight > tab.clientHeight - 100
    },
    onChangePartnerClick(tgtId) {
      this.$emit('change-partner-click', tgtId)
    },
    onRecommendItemClick(item) {
      location.href = item.url
    },
    onFeaturesRecommendCloseClick() {
      this.hideFeatureRecommend = true
    },
  }
}</script>

<style scoped lang="scss">
@import "../../../../sass/commons/commonVariables.scss";
.playlist-group-base {
  width: 100%;
  height: 100%;
  .no-items {
    position: fixed;
    top: 79px;
    bottom: 50px;
    width: 100%;
    max-width: 580px;
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
    font-size: 13px;
    line-height: 19px;
    color: $col_temp_gray5;
    &.hasTabhead {
      top: 117px;
    }
    img {
      display: block;
      margin-bottom: 8px;
    }
  }
  .fixed-button-base {
    position: fixed;
    bottom: 50px;
    left: 0;
    width: 100%;
    padding: 10px 0 16px;
    @include mq('w580'){
      bottom: 0;
    }
    .btn-fin-closedlist {
      transition: opacity 300ms ease-out 0s;
      width: 286px;
      @include mq('w320'){
        width: 315px;
      }
      margin: auto;
    }
  }
}
.clbtn-enter-active,
.clbtn-leave-active {
  transition: all 200ms ease-out 0s;
}
.clbtn-enter, .clbtn-leave-to {
  opacity: 0;
}
.clbtn-enter-to, .clbtn-leave {
  opacity: 1;
  transform: translate(0, 0);
}


//レコメンド
.features-recommend-base {
  width: 100%;
  background: rgba(255,255,255,0.95);
  box-shadow: 0px -2px 8px rgba(218, 218, 218, 0.4);
  position: relative;

  .close-btn {
    display: block;
    width: 30px;
    height: 30px;
    position: absolute;
    top: 15px;
    right: 15px;
    cursor: pointer;
    & > span {
      display: block;
      width: 100%;
      height: 100%;
      position: relative;
      &::before,
      &::after {
        content: "";
        display: block;
        background: #656d78;
        height: 2px;
        border-radius: 2px;
        width: 28px;
        position: absolute;
        top: 0;
        bottom: 0;
        left: 0;
        right: 0;
        margin: auto;
      }
      &::before {
        transform: rotate(-45deg);
      }
      &::after {
        transform: rotate(45deg);
      }
    }
  }

  .recommend-wrap {
    width: 100%;
    margin: auto;
    max-width: 580px;
    padding: 32px 0 40px;
    background: #fff5f8;
    .recommend-block {
      border-radius: 10px;
      margin-bottom: 24px;
      h4 {
        font-size: 16px;
        color: #907d4c;
        padding: 0 20px ;
        margin: 0 0 8px;
      }
      a {
        display: block;
        color: #ff7497;
        font-size: 15px;
        cursor: pointer;
        margin: 0 0 18px;
        text-decoration: underline;
        line-height: 1;
      }
    }
  }
}



</style>



// WEBPACK FOOTER //
// ../../../../resources/assets/js/utvStore/components/Playlist/PlaylistGroup.vue